import React from "react";
import { View, StyleSheet } from "react-native";
import config from "../config/config";
import AppText from "../components/AppText";

function AppTitleBar({ title, subTitle, leftIconComponent, rightIconComponent, midRightIconComponent, midLeftIconComponent, titleComponent }) {
    return (
        <View style={styles.container}>
            <View style={styles.button}>{leftIconComponent}</View>
            <View style={styles.button}>{midLeftIconComponent}</View>
            {(titleComponent || title || subTitle) && (
                <View style={{ flexDirection: "column", flex: 1 }}>
                    {titleComponent && titleComponent}
                    {title && (
                        <AppText numberOfLines={2} style={styles.titleText}>
                            {title}
                        </AppText>
                    )}
                    {subTitle && <AppText style={styles.subTitleText}>{subTitle}</AppText>}
                </View>
            )}
            <View style={styles.button}>{midRightIconComponent}</View>
            <View style={styles.button}>{rightIconComponent}</View>
        </View>
    );
}
const styles = StyleSheet.create({
    titleText: {
        fontWeight: "bold",
        fontSize: 30,
        color: config.colors.white,
        textAlign: "center",
    },
    subTitleText: {
        color: config.colors.white,
        fontWeight: "bold",
        fontSize: 20,
        textTransform: "capitalize",
    },
    container: {
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "space-between",
        marginBottom: 10,
        paddingHorizontal: "2.5%",
        backgroundColor: config.colors.tertiary,
        paddingVertical: 10,
    },
    button: {
        paddingHorizontal: 5,
    },
});
export default AppTitleBar;
